import * as React from "react";
import { Dialog } from "../Dialog/Dialog";
import { Icon } from "../Icon/icon";

export interface SureDeleteProps {
  modalHeading: string;
  modalBody: string;
  cancelText: string;
  actionText: string;
  deletePath: string;
}

export interface SureDeleteState {
  modalIsOpen: boolean;
}

/**
 * Renders a paperbin icon with a text. Clicking on it opens a modal to ask for confirmation of deleting.
 */
export class SureDelete extends React.Component<
  SureDeleteProps,
  SureDeleteState
> {
  constructor(props: SureDeleteProps) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };
  }

  doDelete = () => {
    this.closeConfirm();
    this.deleteItem(this.props.deletePath);
  };

  /**
   * Just navigate to the delete link. After deletion the user will be sent to My Page again.
   */
  deleteItem = (link: string) => {
    window.location.href = link;
  };

  openConfirm = (e: React.MouseEvent) => {
    e.preventDefault();
    this.setState({
      modalIsOpen: true,
    });
  };

  closeConfirm = () => {
    this.setState({
      modalIsOpen: false,
    });
  };

  public render() {
    const { modalHeading, modalBody, cancelText, actionText } = this.props;
    const modalIsOpen = this.state.modalIsOpen;
    return (
      <div className="eservicemenu">
        <button onClick={this.openConfirm} className="stripped-button">
          Ta bort <Icon iconType="Paperbin" />
        </button>
        <Dialog isOpen={modalIsOpen} onRequestClose={this.closeConfirm}>
          <div onClick={this.closeConfirm} className="close">
            <Icon
              isAriaHidden={false}
              ariaLabel="Stäng"
              iconType="ic_close_white_24px"
            />
          </div>
          <div className="header">
            <h2>{modalHeading}</h2>
          </div>
          <p>{modalBody}</p>
          <div className="footer">
            <button
              className="button button--white"
              onClick={this.closeConfirm}
            >
              {cancelText}
            </button>
            <button className="button button--red" onClick={this.doDelete}>
              {actionText}
            </button>
          </div>
        </Dialog>
      </div>
    );
  }
}
